import React from 'react';
import { Loader2 } from 'lucide-react';

const sizeMap = {
  sm: 'h-9 px-4 text-[13.5px]',
  md: 'h-11 px-6 text-[14.5px]',
  lg: 'h-12 px-7 text-[15px]',
};

const variantMap = {
  primary:
    'bg-clay-600 hover:bg-clay-700 text-cream-50 shadow-soft-1 hover:shadow-soft-2',
  ink:
    'bg-ink hover:bg-ink-soft text-cream-50',
  cream:
    'bg-cream-50 hover:bg-cream-100 text-clay-700',
  outline:
    'bg-transparent text-ink-soft border border-border hover:border-clay-400 hover:text-clay-700 hover:bg-cream-100',
  ghost:
    'bg-transparent text-ink-soft hover:bg-cream-100 hover:text-clay-700',
};

/**
 * BrandButton — the canonical Joy Basket button.
 * Replaces ad-hoc `<Button className="bg-clay-600 ...">` patterns.
 * Renders as <button> by default; pass `as` to render an anchor or other element.
 */
export const BrandButton = React.forwardRef(function BrandButton(
  {
    as: Tag = 'button',
    variant = 'primary',
    size = 'md',
    className = '',
    loading = false,
    disabled,
    children,
    ...rest
  },
  ref
) {
  return (
    <Tag
      ref={ref}
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 rounded-full font-medium tracking-[-0.005em]
        transition-all duration-200 select-none
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clay-500/45 focus-visible:ring-offset-2 focus-visible:ring-offset-cream-50
        disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none
        ${sizeMap[size]} ${variantMap[variant]} ${className}`}
      {...rest}
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
      {children}
    </Tag>
  );
});

export default BrandButton;
